let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ccEOP")).then(() => parcelRequire('786IU'));